import { response } from './response';

const interceptors = { response };

export default interceptors;
